// extracted by mini-css-extract-plugin
module.exports = {"title":"title_style_title__1WBxY","popuptitle":"title_style_popuptitle__23M0v"};